import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import '@fontsource/jost/300.css'
import '@fontsource/jost/400.css'
import '@fontsource/jost/500.css'
import '@fontsource-variable/newsreader/opsz.css'
import './index.css'

const root = document.getElementById('root')
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// I produksjon ligger siden ferdig rendret i HTML-en (se prerender.mjs) – da hektes React
// på den eksisterende markupen. I utvikling er roten tom, og siden bygges fra bunnen.
if (root.firstElementChild) ReactDOM.hydrateRoot(root, app)
else ReactDOM.createRoot(root).render(app)
